<template>
    <v-container fluid>
        <v-row>
            <v-col cols="6">
                <v-card>
                    <v-card-title>
                        <span>Chatbot串連設定</span>
                    </v-card-title>
                    <v-card-text>
                        <v-col>
                            <v-text-field v-model="bindChatbot.ChannelID" :rules="[rules.channelID]" label="請輸入Channel ID" :disabled="account_type==3"></v-text-field>
                            <v-text-field v-model="bindChatbot.ChannelSecret" :rules="[rules.channelSecret]" label="請輸入Channel Secret" :disabled="account_type==3"></v-text-field>
                            <v-text-field v-model="bindChatbot.ChannelAccessToken" :rules="[rules.access_token]" label="請輸入Channel Access Token" :disabled="account_type==3"></v-text-field>
                            <v-text-field v-model="bindChatbot.WebhooksURL" :rules="[rules.webhook]" label="請輸入WebhooksURL" :disabled="account_type==3"></v-text-field>
                            <v-text-field v-model="bindChatbot.BasicID" :rules="[rules.basicID]" label="請輸入Basic ID" :disabled="account_type==3"></v-text-field>
                            <span>*以上都為必填</span>
                        </v-col>
                        
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="ml-5" color="success" @click="openCheck()">確認</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="checkDialog" max-width="300px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">確定送出?
                    <v-spacer/>
                    <v-icon @click="checkDialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-actions>        
                    <v-col>
                        <v-btn @click="checkDialog = false;" block>取消</v-btn>
                    </v-col>   
                    <v-col>
                        <v-btn color="success" @click="submit(); checkDialog = false;" block>確定</v-btn>       
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL

export default {
    data(){
        return {
            bindChatbot: {
                ChannelID: '',
                ChannelSecret: '',
                ChannelAccessToken: '',
                WebhooksURL: '',
                BasicID: '',
            },
            rules: {
                access_token: v => v.length >= 172 || '格式有誤! 請再確認',
                basicID: v => v.length >=9 || '格式有誤! 請再確認',
                webhook: v => !!v || '不能為空！',
                channelID: v => v.length >= 10 || '格式有誤! 請再確認',
                channelSecret: v => v.length >= 32 || '格式有誤! 請再確認',
            },
            checkDialog: false,         
            check_has_bot: localStorage.getItem('has_bot'),
            check_link_bot: localStorage.getItem('has_link_bot'),
            account_type: localStorage.getItem('account_type')
        }
    },
    created(){
        if (this.check_has_bot == 'true' && this.check_link_bot == 'false' && this.account_type != 3){
            bus.$emit('alert', {msg: "請先綁定完LINE官方帳號Token才能使用其他功能!", title: "提示",　check: "我知道了"})
        }
        else if (this.check_has_bot == 'true' && this.check_link_bot == 'false' && this.account_type == 3){
            bus.$emit('alert', {msg: "請通知LINE官方帳號管理者綁定完官方帳號Token後, 重登才能使用其他功能!", title: "提示",　check: "我知道了"})
        }
    },
    methods: {
        openCheck(){
            this.checkDialog = true
        },
        submit(){
            console.log(this.bindChatbot)
            let check_status = false
            if(this.bindChatbot.ChannelID == ''){ check_status =true; }
            if(this.bindChatbot.ChannelSecret == ''){ check_status =true; }
            if(this.bindChatbot.ChannelAccessToken == ''){ check_status =true; }
            if(this.bindChatbot.WebhooksURL == ''){ check_status =true; }
            if(this.bindChatbot.BasicID == ''){ check_status =true; }
            let check_ = this.check_data()
            if(check_.status == true){
                bus.$emit('alert', {msg: check_.msg, title: "錯誤提示",　check: "我知道了"})
                return
            }
            if(check_status == true){
                bus.$emit('alert', {msg: "欄位都需輸入, 不能為空", title: "錯誤提示",　check: "我知道了"})
                return
            }
            
            axios.post(host_url+'bind_chatbot/', this.bindChatbot)
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    localStorage.setItem('has_link_bot', true)
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                    this.$router.push('/account_overview')
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        check_data(){
            let check = { msg: "", status: false} 
            if(this.bindChatbot.ChannelID.length < 10 && this.bindChatbot.ChannelID.length != ''){ 
                check.msg="Channel ID 格式錯誤"; check.status = true;}
            if(this.bindChatbot.ChannelSecret.length < 32 && this.bindChatbot.ChannelSecret.length != ''){ 
                check.msg="ChannelSecret 格式錯誤"; status =true; }
            if(this.bindChatbot.ChannelAccessToken.length < 172 && this.bindChatbot.ChannelAccessToken.length != ''){ 
                check.msg="ChannelAccessToken 格式錯誤"; status =true; }
            if(this.bindChatbot.BasicID.length < 9 && this.bindChatbot.BasicID.length != ''){ 
                check.msg="Basic ID 格式錯誤"; status =true; }
            return check
        },
    }
}
</script>